module.exports = __webpack_public_path__ + "img/majesticons_map-marker-area-line.e0534754.svg";